import React from "react";
import PropTypes from "prop-types";
import OverviewSection from "./OverviewSection";
import CartItem from "~/assets/js/components/CartItems/CartItem";
import { applyNoReusableBowlsFilter } from "~/assets/js/Helpers/reusable-bowls-utils";

const CartProducts = ({ cartItems }) => {
    if (!cartItems) {
        return null;
    }

    return (
        <OverviewSection title="overview.productsNoCount">
            {cartItems &&
                cartItems
                    .filter(applyNoReusableBowlsFilter)
                    .map((cartItem, idx) => (
                        <CartItem
                            inCartPosition={idx}
                            key={`cartitem-${idx}`}
                            cartItem={cartItem}
                            items={cartItems}
                            readOnly
                        />
                    ))}
        </OverviewSection>
    );
};

CartProducts.propTypes = {
    cartItems: PropTypes.array,
};

export default CartProducts;
